export default __webpack_public_path__ + "static/media/Bjorn.233a07d7.png";